var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containPcBox"},[_c('Header',{on:{"searchText":_vm.searchText}}),_vm._v(" "),_c('div',{staticClass:"containPcTemplate",style:(_vm.$route.name=='zt'?'background:white':'')},[_c('router-view',{ref:"servicePageSearch"})],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1dcd56e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/todoCenter/default/workflow/layout/index.vue
// module id = 5pD7
// module chunks = 14